/* eslint-disable no-console */

import axios from 'axios';

const HTTP = axios.create();

export default HTTP;



// WEBPACK FOOTER //
// ./src/api/HTTPAsterop.js